"use strict";

/* =========================================================
   VARIABLES

   src=fronend/mantenimiento/anticipo/anticipo.js
========================================================= */

let anticipos = [];

let empleadosAnticipo = [];

let modalNuevo;
let modalEditar;
let modalPago;
let modalEliminar;


/* =========================================================
   INICIALIZAR
========================================================= */

document.addEventListener('DOMContentLoaded', function () {

    /* =====================================================
       MODAL NUEVO
    ====================================================== */

    const elementoModalNuevo =
        document.getElementById('modalNuevoAnticipo');

    if (elementoModalNuevo) {

        modalNuevo =
            new bootstrap.Modal(
                elementoModalNuevo
            );

    }


    /* =====================================================
       MODAL EDITAR
    ====================================================== */

    const elementoModalEditar =
        document.getElementById('modalEditarAnticipo');

    if (elementoModalEditar) {

        modalEditar =
            new bootstrap.Modal(
                elementoModalEditar
            );

    }


    /* =====================================================
       MODAL PAGO
    ====================================================== */

    const elementoModalPago =
        document.getElementById('modalPagoAnticipo');

    if (elementoModalPago) {

        modalPago =
            new bootstrap.Modal(
                elementoModalPago
            );

    }


    /* =====================================================
       MODAL ELIMINAR
    ====================================================== */

    const elementoModalEliminar =
        document.getElementById('modalEliminarAnticipo');

    if (elementoModalEliminar) {

        modalEliminar =
            new bootstrap.Modal(
                elementoModalEliminar
            );

    }


    /* =====================================================
       CARGAR INFORMACIÓN
    ====================================================== */

    cargarAnticipos();

    cargarEmpleadosAnticipo();


    /* =====================================================
       BOTÓN NUEVO ANTICIPO
    ====================================================== */

    const btnNuevoAnticipo =
        document.getElementById(
            'btnNuevoAnticipo'
        );

    if (btnNuevoAnticipo) {

        btnNuevoAnticipo.addEventListener(
            'click',
            abrirNuevoAnticipo
        );

    }


    /* =====================================================
       FORMULARIO NUEVO ANTICIPO
    ====================================================== */

    const formNuevoAnticipo =
        document.getElementById(
            'formNuevoAnticipo'
        );

    if (formNuevoAnticipo) {

        formNuevoAnticipo.addEventListener(
            'submit',
            guardarNuevoAnticipo
        );

    }


    /* =====================================================
       FORMULARIO EDITAR ANTICIPO
    ====================================================== */

    const formEditarAnticipo =
        document.getElementById(
            'formEditarAnticipo'
        );

    if (formEditarAnticipo) {

        formEditarAnticipo.addEventListener(
            'submit',
            guardarEdicionAnticipo
        );

    }


    /* =====================================================
       BOTÓN CONFIRMAR PAGO
    ====================================================== */

    const btnConfirmarPagoAnticipo =
        document.getElementById(
            'btnConfirmarPagoAnticipo'
        );

    if (btnConfirmarPagoAnticipo) {

        btnConfirmarPagoAnticipo.addEventListener(
            'click',
            confirmarPagoAnticipo
        );

    }


    /* =====================================================
       BOTÓN CONFIRMAR ELIMINACIÓN
    ====================================================== */

    const btnConfirmarEliminarAnticipo =
        document.getElementById(
            'btnConfirmarEliminarAnticipo'
        );

    if (btnConfirmarEliminarAnticipo) {

        btnConfirmarEliminarAnticipo.addEventListener(
            'click',
            confirmarEliminarAnticipo
        );

    }


    /* =====================================================
       BUSCAR
    ====================================================== */

    const buscarAnticipo =
        document.getElementById(
            'buscarAnticipo'
        );

    if (buscarAnticipo) {

        buscarAnticipo.addEventListener(
            'input',
            filtrarAnticipos
        );

    }


    /* =====================================================
       LIMPIAR BÚSQUEDA
    ====================================================== */

    const btnLimpiarBusqueda =
        document.getElementById(
            'btnLimpiarBusqueda'
        );

    if (btnLimpiarBusqueda) {

        btnLimpiarBusqueda.addEventListener(
            'click',
            limpiarBusqueda
        );

    }


    /* =====================================================
       SELECCIONAR EMPLEADO
    ====================================================== */

    const selectEmpleado =
        document.getElementById(
            'IDEMPLEADO'
        );

    if (selectEmpleado) {

        selectEmpleado.addEventListener(
            'change',
            cargarDatosEmpleado
        );

    }


    /* =====================================================
       FECHA REGISTRO NUEVO
    ====================================================== */

    const fechaRegistro =
        document.getElementById(
            'FECHAREGISTRO'
        );

    if (fechaRegistro) {

        fechaRegistro.addEventListener(
            'change',
            function () {

                const fecha =
                    this.value;

                const fechaAnticipada =
                    document.getElementById(
                        'FECHAANTICIPADA'
                    );

                if (fechaAnticipada) {

                    fechaAnticipada.value =
                        calcularFechaAnticipo(
                            fecha
                        );

                }

                actualizarEstadoBotonNuevoAnticipo();

            }
        );

    }


    /* =====================================================
       FECHA REGISTRO EDICIÓN
    ====================================================== */

    const editarFechaRegistro =
        document.getElementById(
            'editarFechaRegistro'
        );

    if (editarFechaRegistro) {

        editarFechaRegistro.addEventListener(
            'change',
            function () {

                const fecha =
                    this.value;

                const fechaAnticipada =
                    document.getElementById(
                        'editarFechaAnticipada'
                    );

                if (fechaAnticipada) {

                    fechaAnticipada.value =
                        calcularFechaAnticipo(
                            fecha
                        );

                }

                actualizarEstadoBotonEditar();

            }
        );

    }

});


/* =========================================================
   CARGAR ANTICIPOS
========================================================= */

async function cargarAnticipos() {

    try {

        const respuesta =
            await fetch(
                '/anticipo/listar'
            );


        const texto =
            await respuesta.text();


        let datos;


        try {

            datos =
                JSON.parse(
                    texto
                );

        }
        catch (error) {

            throw new Error(
                texto ||
                'El servidor no devolvió JSON válido.'
            );

        }


        if (!respuesta.ok) {

            throw new Error(
                datos.error ||
                datos.mensaje ||
                'No se pudo obtener la lista de anticipos.'
            );

        }


        anticipos =
            Array.isArray(datos)
                ? datos
                : datos.data ||
                  datos.recordset ||
                  [];


        console.log(
            'ANTICIPOS CARGADOS:',
            anticipos
        );


        renderizarAnticipos(
            anticipos
        );


        actualizarResumen();

    }
    catch (error) {

        console.error(
            'ERROR AL CARGAR ANTICIPOS:',
            error
        );


        const tbody =
            document.getElementById(
                'tbodyAnticipos'
            );


        if (tbody) {

            tbody.innerHTML = `

                <tr>

                    <td
                        colspan="13"
                        class="empty-state">

                        <i class="bi bi-exclamation-circle d-block"></i>

                        No se pudieron cargar los anticipos.

                        <br>

                        <small>
                            ${escaparHTML(error.message)}
                        </small>

                    </td>

                </tr>

            `;

        }

    }

}


/* =========================================================
   CARGAR EMPLEADOS
========================================================= */

async function cargarEmpleadosAnticipo() {

    try {

        const respuesta =
            await fetch(
                '/anticipo/empleados'
            );


        const texto =
            await respuesta.text();


        let datos;


        try {

            datos =
                JSON.parse(
                    texto
                );

        }
        catch {

            throw new Error(
                texto ||
                'El servidor no devolvió JSON válido.'
            );

        }


        if (!respuesta.ok) {

            throw new Error(
                datos.error ||
                datos.mensaje ||
                'No se pudieron cargar los empleados.'
            );

        }


        empleadosAnticipo =
            Array.isArray(datos)
                ? datos
                : datos.data ||
                  datos.recordset ||
                  [];


        const select =
            document.getElementById(
                'IDEMPLEADO'
            );


        if (!select) {

            return;

        }


        select.innerHTML = `

            <option value="">
                Seleccione un empleado
            </option>

        `;


        empleadosAnticipo.forEach(
            function (empleado) {

                const option =
                    document.createElement(
                        'option'
                    );


                option.value =
                    empleado.IDEMPLEADO;


                option.textContent =
                    `${empleado.NOMBREEMPLEADO || ''} - ${empleado.DPI || ''}`;


                option.dataset.dpi =
                    empleado.DPI || '';


                option.dataset.puesto =
                    empleado.NOMBREPUESTO || '';


                option.dataset.departamento =
                    empleado['DEPARTAMENTO TECNOLOGICO'] || '';


                option.dataset.salario =
                    empleado.SALARIOBASE || 0;


                select.appendChild(
                    option
                );

            }
        );

    }
    catch (error) {

        console.error(
            'ERROR AL CARGAR EMPLEADOS:',
            error
        );

    }

}


/* =========================================================
   CARGAR DATOS DEL EMPLEADO
========================================================= */

function cargarDatosEmpleado() {

    const select =
        document.getElementById(
            'IDEMPLEADO'
        );


    if (!select) {

        return;

    }


    const option =
        select.options[
            select.selectedIndex
        ];


    if (
        !option ||
        !option.value
    ) {

        const dpi =
            document.getElementById('DPI');

        const puesto =
            document.getElementById('NOMBREPUESTO');

        const departamento =
            document.getElementById('DEPARTAMENTO');

        const salarioBase =
            document.getElementById('SALARIOBASE');

        const montoAnticipo =
            document.getElementById('MONTOANTICIPO');


        if (dpi) dpi.value = '';

        if (puesto) puesto.value = '';

        if (departamento) departamento.value = '';

        if (salarioBase) salarioBase.value = '';

        if (montoAnticipo) montoAnticipo.value = '';

        return;

    }


    const dpi =
        document.getElementById('DPI');

    const puesto =
        document.getElementById('NOMBREPUESTO');

    const departamento =
        document.getElementById('DEPARTAMENTO');

    const salarioBase =
        document.getElementById('SALARIOBASE');

    const montoAnticipo =
        document.getElementById('MONTOANTICIPO');

    const porcentajeElemento =
        document.getElementById('PORCENTAJE');


    if (dpi) {

        dpi.value =
            option.dataset.dpi || '';

    }


    if (puesto) {

        puesto.value =
            option.dataset.puesto || '';

    }


    if (departamento) {

        departamento.value =
            option.dataset.departamento || '';

    }


    const salario =
        Number(
            option.dataset.salario || 0
        );


    if (salarioBase) {

        salarioBase.value =
            salario.toFixed(2);

    }


    const porcentaje =
        Number(
            porcentajeElemento?.value || 50
        );


    const monto =
        salario *
        (porcentaje / 100);


    if (montoAnticipo) {

        montoAnticipo.value =
            monto.toFixed(2);

    }

}


/* =========================================================
   CALCULAR FECHA ANTICIPO
========================================================= */

function calcularFechaAnticipo(fechaRegistro) {

    if (!fechaRegistro) {

        return '';

    }


    const partes =
        fechaRegistro.split('-');


    const año =
        Number(
            partes[0]
        );


    const mes =
        Number(
            partes[1]
        ) - 1;


    const dia =
        Number(
            partes[2]
        );


    let mesAnticipo =
        mes;


    let añoAnticipo =
        año;


    if (dia > 15) {

        mesAnticipo++;


        if (mesAnticipo > 11) {

            mesAnticipo = 0;

            añoAnticipo++;

        }

    }


    const fechaAnticipo =
        new Date(
            añoAnticipo,
            mesAnticipo,
            15
        );


    return fechaLocalISO(
        fechaAnticipo
    );

}


/* =========================================================
   ABRIR NUEVO ANTICIPO
========================================================= */

function abrirNuevoAnticipo() {

    const formulario =
        document.getElementById(
            'formNuevoAnticipo'
        );


    if (formulario) {

        formulario.reset();

    }


    const porcentaje =
        document.getElementById(
            'PORCENTAJE'
        );

    const proceso =
        document.getElementById(
            'PROCESO'
        );

    const estado =
        document.getElementById(
            'ESTADO'
        );

    const fechaRegistro =
        document.getElementById(
            'FECHAREGISTRO'
        );

    const fechaAnticipo =
        document.getElementById(
            'FECHAANTICIPADA'
        );


    if (porcentaje) {

        porcentaje.value =
            '50';

    }


    if (proceso) {

        proceso.value =
            'ANTICIPO';

    }


    if (estado) {

        estado.value =
            'A';

    }


    const hoy =
        obtenerFechaLocal();


    if (fechaRegistro) {

        fechaRegistro.value =
            hoy;

    }


    if (fechaAnticipo) {

        fechaAnticipo.value =
            calcularFechaAnticipo(
                hoy
            );

    }


    const dpi =
        document.getElementById('DPI');

    const puesto =
        document.getElementById('NOMBREPUESTO');

    const departamento =
        document.getElementById('DEPARTAMENTO');

    const salario =
        document.getElementById('SALARIOBASE');

    const monto =
        document.getElementById('MONTOANTICIPO');


    if (dpi) dpi.value = '';

    if (puesto) puesto.value = '';

    if (departamento) departamento.value = '';

    if (salario) salario.value = '';

    if (monto) monto.value = '';


    actualizarEstadoBotonNuevoAnticipo();


    if (modalNuevo) {

        modalNuevo.show();

    }

}


/* =========================================================
   BLOQUEAR / DESBLOQUEAR BOTÓN NUEVO ANTICIPO
========================================================= */

function actualizarEstadoBotonNuevoAnticipo() {

    const fechaRegistro =
        document.getElementById(
            'FECHAREGISTRO'
        );


    const boton =
        document.getElementById(
            'btnGuardarNuevoAnticipo'
        );


    const alerta =
        document.getElementById(
            'alertaNuevoAnticipoBloqueado'
        );


    if (
        !fechaRegistro ||
        !boton
    ) {

        return;

    }


    if (!fechaRegistro.value) {

        boton.disabled = true;


        boton.innerHTML = `

            <i class="bi bi-lock-fill me-1"></i>

            Fecha requerida

        `;


        if (alerta) {

            alerta.style.display =
                'none';

        }


        return;

    }


    const partes =
        fechaRegistro.value.split('-');


    const dia =
        Number(
            partes[2]
        );


    if (
        isNaN(dia) ||
        dia < 1 ||
        dia > 31
    ) {

        boton.disabled = true;


        boton.innerHTML = `

            <i class="bi bi-lock-fill me-1"></i>

            Fecha inválida

        `;


        if (alerta) {

            alerta.style.display =
                'block';

        }


        return;

    }


    if (dia > 15) {

        boton.disabled = true;


        boton.innerHTML = `

            <i class="bi bi-lock-fill me-1"></i>

            Bloqueado después del día 15

        `;


        if (alerta) {

            alerta.style.display =
                'block';

        }

    }
    else {

        boton.disabled = false;


        boton.innerHTML = `

            <i class="bi bi-check-circle me-1"></i>

            Anticipar

        `;


        if (alerta) {

            alerta.style.display =
                'none';

        }

    }

}


/* =========================================================
   GUARDAR NUEVO ANTICIPO
========================================================= */

async function guardarNuevoAnticipo(event) {

    event.preventDefault();


    const select =
        document.getElementById(
            'IDEMPLEADO'
        );


    if (!select) {

        alert(
            'No se encontró el selector de empleado.'
        );

        return;

    }


    const option =
        select.options[
            select.selectedIndex
        ];


    if (!select.value) {

        alert(
            'Debe seleccionar un empleado.'
        );

        return;

    }


    const fechaRegistro =
        document.getElementById(
            'FECHAREGISTRO'
        ).value;


    if (!fechaRegistro) {

        alert(
            'La fecha de registro es obligatoria.'
        );


        actualizarEstadoBotonNuevoAnticipo();


        return;

    }


    const partesFecha =
        fechaRegistro.split('-');


    const diaFecha =
        Number(
            partesFecha[2]
        );


    if (
        isNaN(diaFecha) ||
        diaFecha < 1 ||
        diaFecha > 31
    ) {

        alert(
            'La fecha de registro no es válida.'
        );


        actualizarEstadoBotonNuevoAnticipo();


        return;

    }


    if (diaFecha > 15) {

        alert(
            'No se puede registrar un anticipo después del día 15 de cada mes.'
        );


        actualizarEstadoBotonNuevoAnticipo();


        return;

    }


    const DPI =
        option.dataset.dpi;


    if (!DPI) {

        alert(
            'El empleado seleccionado no tiene DPI.'
        );

        return;

    }


    try {

        const boton =
            document.getElementById(
                'btnGuardarNuevoAnticipo'
            );


        if (boton) {

            boton.disabled = true;


            boton.innerHTML = `

                <span
                    class="spinner-border spinner-border-sm me-2">
                </span>

                Guardando...

            `;

        }


        const respuesta =
            await fetch(
                '/anticipo/guardar',
                {

                    method: 'POST',

                    headers: {

                        'Content-Type':
                            'application/json',

                        'Accept':
                            'application/json'

                    },

                    body: JSON.stringify({

                        DPI: DPI,

                        FECHAANTICIPADA:
                            document
                                .getElementById(
                                    'FECHAANTICIPADA'
                                )
                                .value

                    })

                }
            );


        const texto =
            await respuesta.text();


        let resultado;


        try {

            resultado =
                texto
                    ? JSON.parse(texto)
                    : {};

        }
        catch {

            resultado = {

                mensaje: texto

            };

        }


        if (!respuesta.ok) {

            throw new Error(
                resultado.error ||
                resultado.mensaje ||
                'No se pudo guardar el anticipo.'
            );

        }


        if (
            resultado.ok === false
        ) {

            throw new Error(
                resultado.error ||
                resultado.mensaje ||
                'No se pudo guardar el anticipo.'
            );

        }


        alert(
            resultado.mensaje ||
            'Anticipo registrado correctamente.'
        );


        if (modalNuevo) {

            modalNuevo.hide();

        }


        await cargarAnticipos();

    }
    catch (error) {

        console.error(
            'ERROR AL GUARDAR ANTICIPO:',
            error
        );


        alert(
            error.message
        );

    }
    finally {

        actualizarEstadoBotonNuevoAnticipo();

    }

}


/* =========================================================
   RENDERIZAR ANTICIPOS
========================================================= */

function renderizarAnticipos(lista) {

    const tbody =
        document.getElementById(
            'tbodyAnticipos'
        );


    if (!tbody) {

        return;

    }


    if (!lista.length) {

        tbody.innerHTML = `

            <tr>

                <td
                    colspan="13"
                    class="empty-state">

                    <i class="bi bi-cash-stack d-block"></i>

                    No hay anticipos registrados.

                </td>

            </tr>

        `;

        return;

    }


    tbody.innerHTML = '';


    lista.forEach(
        function (anticipo, index) {

            const tr =
                document.createElement(
                    'tr'
                );


            const estado =
                String(
                    anticipo['ESTADO ANTICIPO'] ||
                    anticipo.ESTADO ||
                    'A'
                )
                .toUpperCase();


            const proceso =
                anticipo.PROCESO ||
                'ANTICIPO';


            const porcentaje =
                Number(
                    anticipo.PORCENTAJE || 0
                );


            const monto =
                Number(
                    anticipo.MONTOANTICIPO || 0
                );


            const salario =
                Number(
                    anticipo.SALARIOBASE || 0
                );


            const nombre =
                anticipo.NOMBREEMPLEADO ||
                'Sin nombre';


            const inicial =
                nombre
                    .charAt(0)
                    .toUpperCase();


            let claseEstado =
                'badge-activo';


            if (
                estado === 'PAGADO' ||
                estado === 'P'
            ) {

                claseEstado =
                    'badge-pagado';

            }
            else if (
                estado === 'INACTIVO' ||
                estado === 'I'
            ) {

                claseEstado =
                    'badge-inactivo';

            }


            const puedePagar =
                estado !== 'PAGADO' &&
                estado !== 'P';


            tr.innerHTML = `

                <td>
                    ${index + 1}
                </td>


                <td>

                    <div class="d-flex align-items-center">

                        <span class="employee-avatar">
                            ${escaparHTML(inicial)}
                        </span>

                        <span class="employee-name">
                            ${escaparHTML(nombre)}
                        </span>

                    </div>

                </td>


                <td>
                    ${escaparHTML(
                        anticipo.DPI || ''
                    )}
                </td>


                <td>
                    ${escaparHTML(
                        anticipo.NOMBREPUESTO || ''
                    )}
                </td>


                <td>
                    ${escaparHTML(
                        anticipo['DEPARTAMENTO TECNOLOGICO'] || ''
                    )}
                </td>


                <td>
                    ${formatearFecha(
                        anticipo.FECHAREGISTRO
                    )}
                </td>


                <td>
                    ${formatearFecha(
                        anticipo.FECHAANTICIPADA
                    )}
                </td>


                <td class="salario">
                    Q ${salario.toFixed(2)}
                </td>


                <td>

                    <span class="badge-porcentaje">
                        ${porcentaje.toFixed(2)}%
                    </span>

                </td>


                <td class="monto-anticipo">
                    Q ${monto.toFixed(2)}
                </td>


                <td>

                    <span class="${claseEstado}">
                        ${escaparHTML(estado)}
                    </span>

                </td>


                <td>

                    <span class="badge-proceso">
                        ${escaparHTML(proceso)}
                    </span>

                </td>


                <td class="acciones">

                    <button
                        type="button"
                        class="btn-accion btn-editar"
                        title="Editar"
                        onclick="editarAnticipo(${index})">

                        <i class="bi bi-pencil-square"></i>

                    </button>


                    <button
                        type="button"
                        class="btn-accion btn-eliminar"
                        title="Eliminar"
                        onclick="eliminarAnticipo(${index})">

                        <i class="bi bi-trash"></i>

                    </button>


                    <button
                        type="button"
                        class="btn-accion btn-accion-anticipar"
                        title="${
                            puedePagar
                                ? 'Pagar anticipo'
                                : 'Anticipo ya pagado'
                        }"
                        onclick="abrirPagoAnticipo(${index})"
                        ${puedePagar ? '' : 'disabled'}>

                        <i class="bi bi-cash-coin"></i>

                    </button>

                </td>

            `;


            tbody.appendChild(
                tr
            );

        }
    );

}


/* =========================================================
   EDITAR ANTICIPO
========================================================= */

function editarAnticipo(index) {

    console.log(
        'EDITAR ANTICIPO INDEX:',
        index
    );


    const anticipo =
        anticipos[index];


    if (!anticipo) {

        alert(
            'No se encontró el anticipo seleccionado.'
        );

        return;

    }


    const idAnticipo =
        Number(
            anticipo.IDANTICIPO
        );


    let idEmpleado =
        Number(
            anticipo.IDEMPLEADO
        );


    if (
        !Number.isInteger(idEmpleado) ||
        idEmpleado <= 0
    ) {

        const dpiAnticipo =
            String(
                anticipo.DPI || ''
            )
            .replace(/\D/g, '');


        const empleadoEncontrado =
            empleadosAnticipo.find(
                function (empleado) {

                    const dpiEmpleado =
                        String(
                            empleado.DPI || ''
                        )
                        .replace(/\D/g, '');


                    return (
                        dpiEmpleado ===
                        dpiAnticipo
                    );

                }
            );


        if (empleadoEncontrado) {

            idEmpleado =
                Number(
                    empleadoEncontrado.IDEMPLEADO
                );

        }

    }


    if (
        !Number.isInteger(idAnticipo) ||
        idAnticipo <= 0
    ) {

        alert(
            'El ID del anticipo no es válido.'
        );

        return;

    }


    if (
        !Number.isInteger(idEmpleado) ||
        idEmpleado <= 0
    ) {

        alert(
            'El anticipo no contiene un IDEMPLEADO válido.'
        );

        return;

    }


    document.getElementById(
        'editarIdAnticipo'
    ).value =
        idAnticipo;


    document.getElementById(
        'editarIdEmpleado'
    ).value =
        idEmpleado;


    document.getElementById(
        'editarEmpleado'
    ).value =
        anticipo.NOMBREEMPLEADO || '';


    document.getElementById(
        'editarDPI'
    ).value =
        anticipo.DPI || '';


    document.getElementById(
        'editarPuesto'
    ).value =
        anticipo.NOMBREPUESTO || '';


    document.getElementById(
        'editarDepartamento'
    ).value =
        anticipo['DEPARTAMENTO TECNOLOGICO'] || '';


    document.getElementById(
        'editarSalarioBase'
    ).value =
        Number(
            anticipo.SALARIOBASE || 0
        ).toFixed(2);


    const fechaRegistroEditar =
        convertirFechaInput(
            anticipo.FECHAREGISTRO
        );


    document.getElementById(
        'editarFechaRegistro'
    ).value =
        fechaRegistroEditar;


    document.getElementById(
        'editarFechaAnticipada'
    ).value =
        calcularFechaAnticipo(
            fechaRegistroEditar
        );


    document.getElementById(
        'editarPorcentaje'
    ).value =
        Number(
            anticipo.PORCENTAJE || 50
        );


    document.getElementById(
        'editarMontoAnticipo'
    ).value =
        Number(
            anticipo.MONTOANTICIPO || 0
        ).toFixed(2);


    document.getElementById(
        'editarProceso'
    ).value =
        anticipo.PROCESO ||
        'ANTICIPO';


    document.getElementById(
        'editarEstado'
    ).value =
        anticipo['ESTADO ANTICIPO'] ||
        anticipo.ESTADO ||
        'A';


    actualizarEstadoBotonEditar();


    if (modalEditar) {

        modalEditar.show();

    }

}


/* =========================================================
   BLOQUEAR / DESBLOQUEAR BOTÓN DE EDICIÓN
========================================================= */

function actualizarEstadoBotonEditar() {

    const fechaRegistro =
        document.getElementById(
            'editarFechaRegistro'
        );


    const boton =
        document.getElementById(
            'btnGuardarEdicion'
        );


    const alerta =
        document.getElementById(
            'alertaEdicionBloqueada'
        );


    if (
        !fechaRegistro ||
        !boton
    ) {

        return;

    }


    if (!fechaRegistro.value) {

        boton.disabled = true;


        boton.innerHTML = `

            <i class="bi bi-lock-fill me-1"></i>

            Fecha requerida

        `;


        if (alerta) {

            alerta.style.display =
                'none';

        }


        return;

    }


    const partes =
        fechaRegistro.value.split('-');


    const dia =
        Number(
            partes[2]
        );


    if (
        isNaN(dia) ||
        dia < 1 ||
        dia > 31
    ) {

        boton.disabled = true;


        boton.innerHTML = `

            <i class="bi bi-lock-fill me-1"></i>

            Fecha inválida

        `;


        if (alerta) {

            alerta.style.display =
                'block';

        }


        return;

    }


    if (dia > 15) {

        boton.disabled = true;


        boton.innerHTML = `

            <i class="bi bi-lock-fill me-1"></i>

            Bloqueado después del día 15

        `;


        if (alerta) {

            alerta.style.display =
                'block';

        }

    }
    else {

        boton.disabled = false;


        boton.innerHTML = `

            <i class="bi bi-save me-1"></i>

            Guardar cambios

        `;


        if (alerta) {

            alerta.style.display =
                'none';

        }

    }

}


/* =========================================================
   GUARDAR EDICIÓN
========================================================= */

async function guardarEdicionAnticipo(event) {

    event.preventDefault();


    const idAnticipo =
        Number(
            document.getElementById(
                'editarIdAnticipo'
            ).value
        );


    const idEmpleado =
        Number(
            document.getElementById(
                'editarIdEmpleado'
            ).value
        );


    const fechaRegistro =
        document.getElementById(
            'editarFechaRegistro'
        ).value;


    const fechaAnticipada =
        document.getElementById(
            'editarFechaAnticipada'
        ).value;


    const porcentaje =
        Number(
            document.getElementById(
                'editarPorcentaje'
            ).value
        );


    const montoAnticipo =
        Number(
            document.getElementById(
                'editarMontoAnticipo'
            ).value
        );


    const proceso =
        document.getElementById(
            'editarProceso'
        ).value
        .trim();


    const estado =
        document.getElementById(
            'editarEstado'
        ).value
        .trim();


    if (
        !Number.isInteger(idAnticipo) ||
        idAnticipo <= 0
    ) {

        alert(
            'El ID del anticipo no es válido.'
        );

        return;

    }


    if (
        !Number.isInteger(idEmpleado) ||
        idEmpleado <= 0
    ) {

        alert(
            'El ID del empleado es obligatorio.'
        );

        return;

    }


    if (!fechaRegistro) {

        alert(
            'La fecha de registro es obligatoria.'
        );

        return;

    }


    const partesFecha =
        fechaRegistro.split('-');


    const diaFecha =
        Number(
            partesFecha[2]
        );


    if (
        isNaN(diaFecha) ||
        diaFecha < 1 ||
        diaFecha > 15
    ) {

        alert(
            'No se puede guardar ni editar un anticipo después del día 15 de cada mes.'
        );


        actualizarEstadoBotonEditar();


        return;

    }


    if (
        isNaN(porcentaje) ||
        porcentaje <= 0
    ) {

        alert(
            'El porcentaje no es válido.'
        );

        return;

    }


    if (
        isNaN(montoAnticipo) ||
        montoAnticipo <= 0
    ) {

        alert(
            'El monto del anticipo no es válido.'
        );

        return;

    }


    if (!proceso) {

        alert(
            'El proceso es obligatorio.'
        );

        return;

    }


    try {

        const boton =
            document.getElementById(
                'btnGuardarEdicion'
            );


        if (boton) {

            boton.disabled = true;


            boton.innerHTML = `

                <span
                    class="spinner-border spinner-border-sm me-2">
                </span>

                Guardando...

            `;

        }


        const datosEnviar = {

            IDANTICIPO:
                idAnticipo,

            IDEMPLEADO:
                idEmpleado,

            FECHAREGISTRO:
                fechaRegistro,

            FECHAANTICIPADA:
                fechaAnticipada || null,

            PORCENTAJE:
                porcentaje,

            MONTOANTICIPO:
                montoAnticipo,

            PROCESO:
                proceso,

            ESTADO:
                estado || null

        };


        const respuesta =
            await fetch(
                '/anticipo/actualizar',
                {

                    method: 'PUT',

                    headers: {

                        'Content-Type':
                            'application/json',

                        'Accept':
                            'application/json'

                    },

                    body:
                        JSON.stringify(
                            datosEnviar
                        )

                }
            );


        const texto =
            await respuesta.text();


        let resultado = {};


        if (texto) {

            try {

                resultado =
                    JSON.parse(
                        texto
                    );

            }
            catch {

                resultado = {

                    mensaje: texto

                };

            }

        }


        if (!respuesta.ok) {

            throw new Error(
                resultado.error ||
                resultado.mensaje ||
                resultado.message ||
                `Error HTTP ${respuesta.status}`
            );

        }


        if (
            resultado.ok === false
        ) {

            throw new Error(
                resultado.error ||
                resultado.mensaje ||
                'No se pudo actualizar el anticipo.'
            );

        }


        alert(
            resultado.mensaje ||
            resultado.message ||
            'Anticipo actualizado correctamente.'
        );


        if (modalEditar) {

            modalEditar.hide();

        }


        await cargarAnticipos();

    }
    catch (error) {

        console.error(
            'ERROR AL ACTUALIZAR ANTICIPO',
            error
        );


        alert(
            'No se pudo actualizar el anticipo.\n\n' +
            error.message
        );

    }
    finally {

        actualizarEstadoBotonEditar();

    }

}


/* =========================================================
   ABRIR MODAL DE PAGO
========================================================= */

function abrirPagoAnticipo(index) {

    console.log(
        'ABRIR PAGO ANTICIPO INDEX:',
        index
    );


    const anticipo =
        anticipos[index];


    if (!anticipo) {

        alert(
            'No se encontró el anticipo.'
        );

        return;

    }


    const estado =
        String(
            anticipo['ESTADO ANTICIPO'] ||
            anticipo.ESTADO ||
            ''
        )
        .toUpperCase();


    if (
        estado === 'PAGADO' ||
        estado === 'P'
    ) {

        alert(
            'Este anticipo ya se encuentra pagado.'
        );

        return;

    }


    document.getElementById(
        'pagoIdAnticipo'
    ).value =
        anticipo.IDANTICIPO;


    document.getElementById(
        'pagoEmpleado'
    ).value =
        anticipo.NOMBREEMPLEADO || '';


    document.getElementById(
        'pagoDPI'
    ).value =
        anticipo.DPI || '';


    document.getElementById(
        'pagoPuesto'
    ).value =
        anticipo.NOMBREPUESTO || '';


    document.getElementById(
        'pagoDepartamento'
    ).value =
        anticipo['DEPARTAMENTO TECNOLOGICO'] || '';


    document.getElementById(
        'pagoSalarioBase'
    ).value =
        Number(
            anticipo.SALARIOBASE || 0
        ).toFixed(2);


    document.getElementById(
        'pagoMontoAnticipo'
    ).value =
        Number(
            anticipo.MONTOANTICIPO || 0
        ).toFixed(2);


    document.getElementById(
        'pagoFechaAnticipo'
    ).value =
        formatearFecha(
            anticipo.FECHAANTICIPADA
        );


    document.getElementById(
        'pagoPorcentaje'
    ).value =
        Number(
            anticipo.PORCENTAJE || 0
        );


    document.getElementById(
        'pagoProceso'
    ).value =
        anticipo.PROCESO ||
        'ANTICIPO';


    document.getElementById(
        'pagoEstado'
    ).value =
        'PAGADO';


    if (modalPago) {

        modalPago.show();

    }

}


/* =========================================================
   CONFIRMAR PAGO
========================================================= */

async function confirmarPagoAnticipo() {

    const idAnticipo =
        Number(
            document.getElementById(
                'pagoIdAnticipo'
            ).value
        );


    if (
        !Number.isInteger(idAnticipo) ||
        idAnticipo <= 0
    ) {

        alert(
            'El ID del anticipo es obligatorio.'
        );

        return;

    }


    if (
        !confirm(
            '¿Desea marcar este anticipo como PAGADO?'
        )
    ) {

        return;

    }


    const boton =
        document.getElementById(
            'btnConfirmarPagoAnticipo'
        );


    try {

        if (boton) {

            boton.disabled = true;


            boton.innerHTML = `

                <span
                    class="spinner-border spinner-border-sm me-2">
                </span>

                Procesando...

            `;

        }


        const respuesta =
            await fetch(
                '/anticipo/pagar',
                {

                    method: 'PUT',

                    headers: {

                        'Content-Type':
                            'application/json',

                        'Accept':
                            'application/json'

                    },

                    body: JSON.stringify({

                        IDANTICIPO:
                            idAnticipo

                    })

                }
            );


        const texto =
            await respuesta.text();


        let resultado = {};


        try {

            resultado =
                texto
                    ? JSON.parse(texto)
                    : {};

        }
        catch {

            resultado = {

                mensaje: texto

            };

        }


        if (!respuesta.ok) {

            throw new Error(
                resultado.error ||
                resultado.mensaje ||
                'No se pudo pagar el anticipo.'
            );

        }


        if (
            resultado.ok === false
        ) {

            throw new Error(
                resultado.error ||
                resultado.mensaje ||
                'No se pudo pagar el anticipo.'
            );

        }


        alert(
            resultado.mensaje ||
            'Anticipo marcado como PAGADO correctamente.'
        );


        if (modalPago) {

            modalPago.hide();

        }


        await cargarAnticipos();

    }
    catch (error) {

        console.error(
            'ERROR AL PAGAR:',
            error
        );


        alert(
            error.message
        );

    }
    finally {

        if (boton) {

            boton.disabled = false;


            boton.innerHTML = `

                <i class="bi bi-check-circle-fill me-1"></i>

                Confirmar pago

            `;

        }

    }

}


/* =========================================================
   ELIMINAR ANTICIPO
========================================================= */

function eliminarAnticipo(index) {

    console.log(
        'ELIMINAR ANTICIPO INDEX:',
        index
    );


    const anticipo =
        anticipos[index];


    if (!anticipo) {

        alert(
            'No se encontró el anticipo.'
        );

        return;

    }


    const idAnticipo =
        Number(
            anticipo.IDANTICIPO
        );


    if (
        !Number.isInteger(idAnticipo) ||
        idAnticipo <= 0
    ) {

        alert(
            'El ID del anticipo no es válido.'
        );

        return;

    }


    const campoId =
        document.getElementById(
            'eliminarIdAnticipo'
        );


    const campoEmpleado =
        document.getElementById(
            'eliminarNombreEmpleado'
        );


    if (campoId) {

        campoId.value =
            idAnticipo;

    }


    if (campoEmpleado) {

        campoEmpleado.textContent =
            anticipo.NOMBREEMPLEADO ||
            '--';

    }


    if (modalEliminar) {

        modalEliminar.show();

    }
    else {

        console.error(
            'El modal modalEliminarAnticipo no fue inicializado.'
        );

    }

}


/* =========================================================
   CONFIRMAR ELIMINACIÓN
========================================================= */

async function confirmarEliminarAnticipo() {

    const campoId =
        document.getElementById(
            'eliminarIdAnticipo'
        );


    if (!campoId) {

        alert(
            'No se encontró el campo IDANTICIPO.'
        );

        return;

    }


    const idAnticipo =
        Number(
            campoId.value
        );


    if (
        !Number.isInteger(idAnticipo) ||
        idAnticipo <= 0
    ) {

        alert(
            'El ID del anticipo es obligatorio.'
        );

        return;

    }


    if (
        !confirm(
            '¿Está seguro de eliminar este anticipo?'
        )
    ) {

        return;

    }


    const boton =
        document.getElementById(
            'btnConfirmarEliminarAnticipo'
        );


    try {

        /* =================================================
           DESHABILITAR BOTÓN
        ================================================= */

        if (boton) {

            boton.disabled = true;


            boton.innerHTML = `

                <span
                    class="spinner-border spinner-border-sm me-2">
                </span>

                Eliminando...

            `;

        }


        console.log(
            '=========================================='
        );

        console.log(
            'ELIMINANDO ANTICIPO'
        );

        console.log(
            'IDANTICIPO:',
            idAnticipo
        );

        console.log(
            'RUTA:',
            '/anticipo/eliminar'
        );

        console.log(
            'MÉTODO:',
            'PUT'
        );

        console.log(
            '=========================================='
        );


        /* =================================================
           IMPORTANTE

           NO SE CAMBIA LA RUTA

           RUTA ORIGINAL:
           /anticipo/eliminar

           MÉTODO DEL BACKEND:
           PUT

           ANTES ESTABA:
           DELETE

           AHORA:
           PUT
        ================================================== */

        const respuesta =
            await fetch(
                '/anticipo/eliminar',
                {

                    method: 'PUT',

                    headers: {

                        'Content-Type':
                            'application/json',

                        'Accept':
                            'application/json'

                    },

                    body: JSON.stringify({

                        IDANTICIPO:
                            idAnticipo

                    })

                }
            );


        /* =================================================
           LEER RESPUESTA DEL SERVIDOR
        ================================================== */

        const texto =
            await respuesta.text();


        console.log(
            'RESPUESTA SERVIDOR:',
            texto
        );


        let resultado = {};


        try {

            resultado =
                texto
                    ? JSON.parse(texto)
                    : {};

        }
        catch {

            resultado = {

                mensaje:
                    texto

            };

        }


        /* =================================================
           VALIDAR HTTP
        ================================================== */

        if (!respuesta.ok) {

            throw new Error(

                resultado.error ||

                resultado.mensaje ||

                resultado.message ||

                `Error HTTP ${respuesta.status}`

            );

        }


        /* =================================================
           VALIDAR OK DEL BACKEND
        ================================================== */

        if (
            resultado.ok === false
        ) {

            throw new Error(

                resultado.error ||

                resultado.mensaje ||

                resultado.message ||

                'No se pudo eliminar el anticipo.'

            );

        }


        /* =================================================
           MENSAJE
        ================================================== */

        alert(

            resultado.mensaje ||

            resultado.message ||

            'Anticipo eliminado correctamente.'

        );


        /* =================================================
           CERRAR MODAL
        ================================================== */

        if (modalEliminar) {

            modalEliminar.hide();

        }


        /* =================================================
           RECARGAR TABLA
        ================================================== */

        await cargarAnticipos();


    }
    catch (error) {

        console.error(
            '=========================================='
        );

        console.error(
            'ERROR AL ELIMINAR ANTICIPO'
        );

        console.error(
            error
        );

        console.error(
            '=========================================='
        );


        alert(
            error.message
        );

    }
    finally {

        /* =================================================
           RESTAURAR BOTÓN
        ================================================= */

        if (boton) {

            boton.disabled = false;


            boton.innerHTML = `

                <i class="bi bi-trash-fill me-1"></i>

                Eliminar

            `;

        }

    }

}


/* =========================================================
   FILTRAR ANTICIPOS
========================================================= */

function filtrarAnticipos() {

    const input =
        document.getElementById(
            'buscarAnticipo'
        );


    if (!input) {

        return;

    }


    const texto =
        input.value
            .toLowerCase()
            .trim();


    if (!texto) {

        renderizarAnticipos(
            anticipos
        );

        return;

    }


    const filtrados =
        anticipos.filter(
            function (anticipo) {

                const contenido = [

                    anticipo.NOMBREEMPLEADO,

                    anticipo.DPI,

                    anticipo.NOMBREPUESTO,

                    anticipo[
                        'DEPARTAMENTO TECNOLOGICO'
                    ],

                    anticipo.PROCESO,

                    anticipo[
                        'ESTADO ANTICIPO'
                    ],

                    anticipo.ESTADO

                ]
                .join(' ')
                .toLowerCase();


                return contenido.includes(
                    texto
                );

            }
        );


    renderizarAnticipos(
        filtrados
    );

}


/* =========================================================
   LIMPIAR BÚSQUEDA
========================================================= */

function limpiarBusqueda() {

    const input =
        document.getElementById(
            'buscarAnticipo'
        );


    if (input) {

        input.value = '';

    }


    renderizarAnticipos(
        anticipos
    );

}


/* =========================================================
   ACTUALIZAR RESUMEN
========================================================= */

function actualizarResumen() {

    const totalAnticipos =
        document.getElementById(
            'totalAnticipos'
        );


    if (totalAnticipos) {

        totalAnticipos.textContent =
            anticipos.length;

    }


    const empleados =
        new Set(
            anticipos
                .map(
                    function (anticipo) {

                        return anticipo.IDEMPLEADO;

                    }
                )
                .filter(Boolean)
        );


    const totalEmpleados =
        document.getElementById(
            'totalEmpleados'
        );


    if (totalEmpleados) {

        totalEmpleados.textContent =
            empleados.size;

    }


    const total =
        anticipos.reduce(
            function (
                acumulado,
                anticipo
            ) {

                return acumulado +
                    Number(
                        anticipo.MONTOANTICIPO || 0
                    );

            },
            0
        );


    const montoTotal =
        document.getElementById(
            'montoTotal'
        );


    if (montoTotal) {

        montoTotal.textContent =
            `Q ${total.toFixed(2)}`;

    }

}


/* =========================================================
   FORMATEAR FECHA
========================================================= */

function formatearFecha(fecha) {

    if (!fecha) {

        return '';

    }


    const valor =
        String(fecha);


    if (
        valor.includes('T')
    ) {

        return valor
            .split('T')[0]
            .split('-')
            .reverse()
            .join('/');

    }


    if (
        /^\d{4}-\d{2}-\d{2}$/.test(
            valor
        )
    ) {

        return valor
            .split('-')
            .reverse()
            .join('/');

    }


    return valor;

}


/* =========================================================
   CONVERTIR FECHA PARA INPUT DATE
========================================================= */

function convertirFechaInput(fecha) {

    if (!fecha) {

        return '';

    }


    const valor =
        String(fecha);


    if (
        valor.includes('T')
    ) {

        return valor
            .split('T')[0];

    }


    if (
        /^\d{4}-\d{2}-\d{2}$/.test(
            valor
        )
    ) {

        return valor;

    }


    return '';

}


/* =========================================================
   FECHA LOCAL ISO
========================================================= */

function fechaLocalISO(fecha) {

    const año =
        fecha.getFullYear();


    const mes =
        String(
            fecha.getMonth() + 1
        )
        .padStart(
            2,
            '0'
        );


    const dia =
        String(
            fecha.getDate()
        )
        .padStart(
            2,
            '0'
        );


    return `${año}-${mes}-${dia}`;

}


/* =========================================================
   OBTENER FECHA LOCAL
========================================================= */

function obtenerFechaLocal() {

    return fechaLocalISO(
        new Date()
    );

}


/* =========================================================
   ESCAPAR HTML
========================================================= */

function escaparHTML(valor) {

    if (
        valor === null ||
        valor === undefined
    ) {

        return '';

    }


    return String(valor)

        .replaceAll(
            '&',
            '&amp;'
        )

        .replaceAll(
            '<',
            '&lt;'
        )

        .replaceAll(
            '>',
            '&gt;'
        )

        .replaceAll(
            '"',
            '&quot;'
        )

        .replaceAll(
            "'",
            '&#039;'
        );

}


/* =========================================================
   EXPONER FUNCIONES AL WINDOW
========================================================= */

window.editarAnticipo =
    editarAnticipo;


window.eliminarAnticipo =
    eliminarAnticipo;


window.abrirPagoAnticipo =
    abrirPagoAnticipo;